import { FormControl, Grid, Select, SelectChangeEvent, selectClasses, Stack, styled } from "@mui/material";
import UserRoles, { isRole } from "../../constants/roles";
import IconInfo from "../common/IconInfo";
import { ClearSearchButton, FilterLabel, FilterSearchText } from "../Filters";
import { Pill } from "../ui/Pill";
import { MenuItemStyled } from "../ui/rolesChip";

const ExplainSearch = () => {
  const text = (
    <div>
      <span>Search by name or email.</span>
    </div>
  );

  return <IconInfo text={text} />;
};

const SelectStyled = styled(Select<string[]>)(({ theme }) => ({
  [`& .${selectClasses.select}`]: {
    padding: theme.spacing(1),
  },
}));

interface IListUsersFilters {
  roles?: string[] | null;
  nameOrEmail?: string | null;
}

const ListUsersFilters = ({
  onChange,
  roles,
  onClear,
  nameOrEmail,
}: {
  onChange: React.Dispatch<
    React.SetStateAction<{
      roles: string[] | null;
      nameOrEmail: string | null;
    }>
  >;
  roles: string[] | null;
  nameOrEmail: string | null;
  onClear: () => void;
}) => {
  const getCurrent = () => {
    return { roles, nameOrEmail };
  };

  const handleChange = (newFilters: IListUsersFilters) => {
    onChange(Object.assign({}, getCurrent(), newFilters));
  };
  return (
    <Grid container spacing={4} sx={{ mb: 4, pt: 4 }}>
      <Grid>
        <FilterLabel>Roles:</FilterLabel>
        <FormControl>
          <SelectStyled
            value={roles || []}
            id={"roles"}
            multiple
            sx={{ minWidth: "200px" }}
            renderValue={(roles: string[]) => {
              return (
                <Stack direction={"row"} spacing={1}>
                  {roles?.filter(isRole).map((role) => {
                    return (
                      <Pill
                        key={UserRoles[role].label}
                        label={UserRoles[role].label}
                        role={UserRoles[role].value}
                        data-cy={UserRoles[role].value}
                        size="small"
                      />
                    );
                  })}
                </Stack>
              );
            }}
            data-testid="filter-roles"
            onChange={(e: SelectChangeEvent<string[]>) => {
              handleChange({
                roles: e.target.value.length > 0 ? (e.target.value as string[]) : null,
              });
            }}
          >
            {Object.values(UserRoles).map((role) => (
              <MenuItemStyled key={role.value} value={role.value} data-role={role.value}>
                {role.label}
              </MenuItemStyled>
            ))}
          </SelectStyled>
        </FormControl>
      </Grid>
      <Grid>
        <FilterSearchText
          search={nameOrEmail || ""}
          onChange={(value) => handleChange({ nameOrEmail: value })}
          explain={<ExplainSearch />}
        />
      </Grid>
      <Grid sx={{ mt: 2 }}>
        <ClearSearchButton onClear={onClear} text="Clear all filters" />
      </Grid>
    </Grid>
  );
};

export { ListUsersFilters };
